import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { Popover } from '@material-ui/core';
import Button from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Button';
import moment from 'moment';

const styles = (theme) => ({
  root: {},
  popoverPaper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.palette.facet.backgroundGray2,
    marginTop: theme.spacing(1),
    padding: theme.spacing(2),
    flexDirection: 'column',
    gap: `${theme.spacing(1)}px`,
  },
  availabilityContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    width: 300,
  },
  availabilityButton: {
    backgroundColor: theme.palette.facet.accentBlue2,
    color: theme.palette.common.white,
    fontWeight: 'bold',
    flex: '0 32%',
    marginBottom: '2%',
    padding: theme.spacing(1, 1.5),
  },
});

const SchedulerDayPopover = ({
  anchorEl,
  className,
  classes,
  onClose,
  onEnter,
  open,
  onClickAvailableTime,
  meetingAvailabilities,
}) => {
  return (
    <Popover
      className={classNames(className, classes.root)}
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      onEnter={onEnter}
      elevation={0}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      PaperProps={{
        className: classes.popoverPaper,
      }}
    >
      <div className={classes.availabilityContainer}>
        {meetingAvailabilities.map((resource) => (
          <Button
            className={classes.availabilityButton}
            onClick={() => onClickAvailableTime(resource)}
            variant="contained"
            test="client-desktop-scheduler-available-time"
            disableElevation
          >
            {moment(resource.attr('startTime')).format('h:mm a')}
          </Button>
        ))}
      </div>
    </Popover>
  );
};

SchedulerDayPopover.defaultProps = {
  className: '',
};

SchedulerDayPopover.propTypes = {
  anchorEl: PropTypes.object.isRequired,
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  onEnter: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  onClickAvailableTime: PropTypes.func.isRequired,
  meetingAvailabilities: PropTypes.array.isRequired,
};

export default withStyles(styles)(SchedulerDayPopover);
